/* istanbul ignore file */

import React, { ReactNode } from 'react';
import styles from './InformationBox.module.scss';

export interface InformationBoxProps {
  text: ReactNode;
}

function InformationBox(props: InformationBoxProps) {
  return (
    <div className={styles.informationBox}>
      {props.text}
    </div>
  );
}

export default InformationBox;
